import React from 'react'
import PropTypes from 'prop-types'
import RadioButton from '../../atoms/RadioButton'
import { Label, Box, Text, Divider } from 'pcln-design-system'

class RadioButtonCategoryGroup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.filters,
    }
  }

  handleOnClick = (item) => {
    if (!this.props.useInternalState) {
      this.props.handleChange(item)
    } else {
      this.setState({
        items: this.state.items.map((i) => {
          if (i.checked) {
            i.checked = false
          }
          if (item.id === i.id) {
            i.checked = true
            this.props.handleChange(i)
          }
          return i
        }),
      })
    }
  }

  render() {
    const { includeDivider, title, useInternalState } = this.props
    const filterItems = useInternalState ? this?.state?.items : this?.props?.filters

    return (
      <Box>
        {title && (
          <Label>
            <Text bold fontWeight='bold' fontSize={2}>
              {title}
            </Text>
          </Label>
        )}
        {filterItems.map((item) => (
          <RadioButton
            data-test='radio-button'
            {...item}
            onClick={this.handleOnClick}
            key={item.id.toString()}
          />
        ))}
        {includeDivider && <Divider pt={2} />}
      </Box>
    )
  }
}

RadioButtonCategoryGroup.propTypes = {
  filters: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  includeDivider: PropTypes.bool,
  title: PropTypes.string,
  useInternalState: PropTypes.bool,
}

RadioButtonCategoryGroup.defaultProps = {
  useInternalState: true,
}

export default RadioButtonCategoryGroup
